module.exports = __webpack_public_path__ + "img/macro04.3333f1d4.png";